import React from 'react';
import classNames from 'classnames';
import Navigation from './Navigation';
import { Button } from '../../Generic/Button';
import { DropDownPopUp } from '../DropDownPopUp/DropDownPopUp';
import config from '../../../config';

export default function NavigationDesktop(props) {
  let {
    styles,
    Menustyles,
    headerData,
    locale,
    toggleShowHide,
    isSearchExpanded,
    handleCountryShow,
    showCountry,
    userStore,
    showdropdownPopup
  } = props;
  const { isLoggedIn, userName, logout } = userStore;
  const i18nMessages = require(`../../../constants/messages/${locale}`);

  return (
    <>
      <div className={classNames(styles.navbarContainer)}>
        <div className={classNames(styles.navbarRow)}>
          <div className={classNames(styles.navbarLeft)}>
            <Navigation
              menuData={headerData.primaryNavCollection.items}
              locale={locale}
              userStore={userStore}
            />
          </div>
        </div>
      </div>
      <div className={classNames(styles.countryDiv)}>
        <div className={classNames(Menustyles.searchButtonWrapper)}>
          <Button
            className={classNames(styles.searchicon)}
            onClick={() => toggleShowHide()}
            aria-label={`Buscar${isSearchExpanded ? ', selecionado' : ', não selecionado'}`}
            aria-pressed={isSearchExpanded ? "true" : "false"}
            aria-expanded={isSearchExpanded ? "true" : "false"}
            aria-controls="search-modal"
            aria-haspopup="dialog"
          >
            <span className={classNames(Menustyles.icon_search)}>
              {''}
            </span>
            <span className={classNames(Menustyles.searchTxt)}>
              {i18nMessages.searchText}
            </span>
          </Button>
          <div
            role="status" 
            aria-live="polite" 
            aria-atomic="true"
            className="sr-only"
            style={{ position: 'absolute', left: '-10000px', width: '1px', height: '1px', overflow: 'hidden' }}
          >
            {isSearchExpanded ? 'Buscar button Expanded' : ''}
          </div>
        </div>
        <div className={classNames(styles.countryContainer)}>
          <Button
            onClick={handleCountryShow}
            className={styles.countryButton}
            aria-label={`Seleção de país${showCountry ? ', selecionado' : ', não selecionado'}`}
            aria-pressed={showCountry ? "true" : "false"}
            aria-expanded={showCountry ? "true" : "false"}
            aria-controls="country-selector-dialog"
            aria-haspopup="dialog"
          >
            <span className={styles.countryButtonText}>
              {i18nMessages.countryLabel}
            </span>
            <span
              className={classNames(
                showCountry ? styles.downArrow : styles.upArrow
              )}
              aria-hidden="true"
            />
          </Button>
          {/* Live region for screen reader announcements */}
          <div 
            role="status" 
            aria-live="polite" 
            aria-atomic="true"
            className="sr-only"
            style={{ position: 'absolute', left: '-10000px', width: '1px', height: '1px', overflow: 'hidden' }}
          >
            {showCountry ? 'Seletor de país expandido, selecionado' : 'Seletor de país recolhido'}
          </div>
          {!config.registrationDisabled && (
          <div className={styles.loginContainer}>
            {isLoggedIn ? (
              <div>
                <Button
                  className={styles.countryButton}
                  onClick={() => this.handleLoginClick()}
                >
                  <span>{userName}</span>
                </Button>
                <div className={styles.loggedIn}>
                  <DropDownPopUp
                    locale={locale}
                    showdropdownPopup={showdropdownPopup}
                    logout={logout}
                  />
                </div>
              </div>
            ) : (
              <div>
                <Button
                  to={headerData.crmSection.loginUrl}
                  className={classNames(styles.countryButton)}
                >
                  <span className={styles.loginButtonText}>
                    {headerData.crmSection.loginText}
                  </span>
                </Button>
                <Button
                  to={headerData.crmSection.registrerUrl}
                  className={classNames(
                    styles.countryButton,
                    'event_profile_register_view_form'
                  )}
                  data-action-detail="register"
                >
                  <span className={styles.registerButtonText}>
                    {headerData.crmSection.registerText}
                  </span>
                </Button>
              </div>
            )}
          </div>
)}
        </div>
      </div>
    </>
  );
}